"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _portals = require("@mulesoft/exchange-ui-portals-store/lib/domains/portals");
var _exchangeUiPortalsStore = require("@mulesoft/exchange-ui-portals-store");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _PagesTree = _interopRequireDefault(require("./PagesTree"));
var mapStateToProps = function mapStateToProps(state, _ref) {
  var _ref$asset = _ref.asset,
    groupId = _ref$asset.groupId,
    assetId = _ref$asset.assetId,
    version = _ref$asset.version,
    isDraft = _ref.isDraft;
  return {
    isSavingPagesOrder: _portals.selectors.isSavingPagesOrder(state),
    pages: _exchangeUiPortalsStore.selectors.selectPages(state, {
      groupId: groupId,
      assetId: assetId,
      version: version,
      isDraft: isDraft
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onOrderPages: function onOrderPages(payload) {
      return dispatch(_portals.actions.orderPages(payload));
    }
  };
};
var _default = exports.default = (0, _redux.compose)(_exchangeReactHooks.withRouter, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(_PagesTree.default);
//# sourceMappingURL=PagesTree.container.js.map